import React from 'react';
import UserDropDown from './UserDropDown';

export const UserWidget = () => {
    return (
        <div>
            <UserDropDown/>
        </div>
    )
}